import React from 'react';
import { Box, Typography, Paper, Button, Stack } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const NoModuleEnabled: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', bgcolor: '#f4f6f8' }}>
      <Paper elevation={3} sx={{ p: 5, borderRadius: 3, minWidth: 360, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <BlockIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
        <Typography variant="h4" gutterBottom fontWeight={700} color="text.primary">
          No Modules Enabled
        </Typography>
        <Typography variant="body1" color="text.secondary" align="center" sx={{ mb: 2 }}>
          None of the main modules (Performance Management, Risk, or Compliance) are enabled for your organization.<br />
          Please contact your administrator for access or to enable modules.
        </Typography>
        <Stack spacing={2} sx={{ width: '50%', mt: 1 }}>
          <Button
            variant="contained"
            color="primary"
            href="mailto:admin@yourcompany.com"
            sx={{ textTransform: 'none', fontWeight: 600 }}
            fullWidth
          >
            Contact Administrator
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleLogout}
            sx={{ textTransform: 'none', fontWeight: 600 }}
            fullWidth
          >
            Go to Login
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default NoModuleEnabled; 